import React from "react";

const OutstandingTable = ({ items, totalOutstanding }) => {
  return (
    <div className="card shadow-sm mt-3">
      <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
        <span>Outstanding Details</span>
        <span className="badge bg-light text-primary fs-6">
          Total: {totalOutstanding.toLocaleString(undefined, { minimumFractionDigits: 2 })}
        </span>
      </div>
      <div className="card-body p-0">
        <div className="table-responsive">
          <table className="table table-hover mb-0">
            <thead className="table-light">
              <tr>
                <th style={{ width: "30%" }}>Customer Name</th>
                <th style={{ width: "45%" }}>Service Wise Breakdown</th>
                <th style={{ width: "25%" }} className="text-end">Total Outstanding</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center p-4 text-muted">
                    No outstanding payments found for the selected period.
                  </td>
                </tr>
              ) : (
                items.map((item, idx) => (
                  <tr key={idx}>
                    <td className="fw-bold text-primary">{item.customer_name}</td>
                    <td>
                      <div className="d-flex flex-wrap gap-2">
                        {item.services.map((svc, sIdx) => (
                          <span key={sIdx} className="badge bg-info text-dark">
                            {svc.service_type}: {svc.amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                          </span>
                        ))}
                      </div>
                    </td>
                    <td className="text-end fw-bold text-danger">
                      {item.total_outstanding.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            {items.length > 0 && (
              <tfoot className="table-light">
                <tr>
                  <th colSpan="2" className="text-end">Grand Total Outstanding:</th>
                  <th className="text-end text-danger fs-5">
                    {totalOutstanding.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                  </th>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>
    </div>
  );
};

export default OutstandingTable;
